import { type ValidatorFn } from '@angular/forms';

import { type TableColumnFormat } from '@blaze-shared/elements-domain';

export type InputConfigType = 'email' | 'number' | 'text' | 'phoneNumber' | 'url' | 'zipcode';

export interface InputConfig {
  type: InputConfigType;
  validators?: ValidatorFn | ValidatorFn[] | null;
  invalidMsg?: string;
}

const inputValidationConfigMap: Record<string, InputConfig> = {
  text: { type: 'text' },
  paragraph: { type: 'text' },
};

export function getInputValidationConfig(format: TableColumnFormat): InputConfig {
  return inputValidationConfigMap[format] || inputValidationConfigMap.text;
}
